export default __webpack_public_path__ + "static/media/Tehseen.bad72637.png";